import MobileNavTab from "./MobileNavTab";
import ClipNavIcon from "./ClipNavIcon";

export default function ClipButton({ isActive }) {
	return (
		<MobileNavTab
			to="/video_clips/"
			label="کلیپ"
			icon={ClipNavIcon}
			isActive={isActive}
		/>
	);
}
